const benefits = [
  {
    icon: "ri-global-line",
    title: "1000+ Servers",
    description:
      "Connect to secure servers across the globe with fast, reliable VPN access from any location",
  },
  {
    icon: "ri-shield-check-line",
    title: "All-in-One App",
    description:
      "VPN, AdBlock, IP checker, and speed test — all essential privacy tools in a single app",
  },
  {
    icon: "ri-wifi-line",
    title: "Public Wi-Fi Safe",
    description:
      "Stay protected on any public Wi-Fi network with encrypted traffic and hidden IP address",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Expert Support",
    description:
      "24/7 technical support team ready to help you with any questions or issues",
  },
];

export default function WhyChooseSection() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4 font-heading">
            Why Choose Online Shield
          </h2>
          <p className="text-lg text-foreground-600 max-w-3xl mx-auto">
            Experience the advantages of next-generation privacy and security technology
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="text-center p-6 bg-background-50 rounded-xl hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-foreground-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}